module.exports = __webpack_public_path__ + "img/discover.ecd9b806.svg";